import { render, staticRenderFns } from "./PharmacyGroupMainDetails.vue?vue&type=template&id=10265b9a"
import script from "./PharmacyGroupMainDetails.vue?vue&type=script&lang=js"
export * from "./PharmacyGroupMainDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports